// extracted by mini-css-extract-plugin
module.exports = {"main":"AboutUs_main__3XagN"};